import { IEmailSettings } from '@backend/domain'
import { ApiProperty } from '@nestjs/swagger'
import { IsNotEmpty, IsString } from 'class-validator'

export class EmailSettings implements IEmailSettings {
	@ApiProperty({ type: String })
	@IsNotEmpty()
	@IsString()
	feedbackContent: string
}
